import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/auth-context";

interface ProtectedRouteProps {
  // isAllowed: boolean;
  redirectPath?: string;
}

const ProtectedRoute = ({
  // isAllowed,
  redirectPath = "/login",
}: ProtectedRouteProps) => {
  const { token } = useAuth();
  if (!token) {
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
